import { forwardRef } from 'react';
import MaterialGrow, { GrowProps } from '@mui/material/Grow';

export const Grow = forwardRef<HTMLDivElement, GrowProps>((props, ref) => {
    return <MaterialGrow ref={ref} data-testid={'Grow-container'} {...props} />;
});

export default Grow;
